<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Visor de Documentos Emitidos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Análisis</span>
      <span> /</span>
      <span>Visor de Documentos Emitidos </span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
      </div>
      <!-- <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Mes/Período'" required
              formControlName="mesPeriodo"></mdb-date-picker>
          </div>
        </div>

        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Gestión'" required
              formControlName="gestion"></mdb-date-picker>
          </div>
        </div>
      </div> -->


      <!-- <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <pre>{{formHeader.value | json}}</pre>
        </div>
      </div> -->


      <div class="row filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-select label="Mes/Periodo" [options]="optionsMonth" placeholder="Mes/Periodo" [filterEnabled]="true"
              formControlName="mesPeriodo">
            </mdb-select>
            <div *ngIf="
                formHeader.get('mesPeriodo').invalid &&
                (formHeader.get('mesPeriodo').dirty ||
                formHeader.get('mesPeriodo').touched)
              ">
              <mdb-error *ngIf="formHeader.get('mesPeriodo').hasError('required')">Ingrese periodo
              </mdb-error>
            </div>
          </div>
        </div>

        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-select label="Gestión" [options]="optionsYear" placeholder="Gestión" [filterEnabled]="true"
              formControlName="gestion">
            </mdb-select>
            <div *ngIf="
                  formHeader.get('gestion').invalid &&
                  (formHeader.get('gestion').dirty ||
                  formHeader.get('gestion').touched)
                ">
              <mdb-error *ngIf="formHeader.get('gestion').hasError('required')">Ingrese gestión
              </mdb-error>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive" *ngIf="listaDocumentos">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <!-- <th scope="col">Tipo</th> -->
            <th scope="col">Detalle Documento</th>
            <th scope="col">Pendientes</th>
            <th scope="col">Enviados</th>
            <th scope="col">cRespuesta</th>
            <th scope="col">sRespuesta</th>
            <th scope="col">Aceptados</th>
            <th scope="col">Reparos</th>
            <th scope="col">Rechazados</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaDocumentos?.length === 0">
            <td colspan="100%" style="text-align: center">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let doc of listaDocumentos">
            <!-- <td>{{ doc.tipoDescripcionAbreviada }}</td> -->
            <td>{{ doc.tipoDescripcion }}</td>
            <td (click)="loadAndShowDetalle(doc, 'PENDIENTE')" class="custom_link">{{ doc.pendientes }}</td>
            <td (click)="loadAndShowDetalle(doc, 'ENV')" class="custom_link">{{ doc.enviados }}</td>
            <td (click)="loadAndShowDetalle(doc, 'CRESP')" class="custom_link">{{ doc.cRespuesta }}</td>
            <td (click)="loadAndShowDetalle(doc, 'SRESP')" class="custom_link">{{ doc.sRespuesta }}</td>
            <td (click)="loadAndShowDetalle(doc, 'ACEPTADO')" class="custom_link">{{ doc.aceptados }}</td>
            <td (click)="loadAndShowDetalle(doc, 'REPARO')" class="custom_link">{{ doc.reparos }}</td>
            <td (click)="loadAndShowDetalle(doc, 'RECHAZADO')" class="custom_link">{{ doc.rechazados }}</td>
            <td (click)="loadAndShowDetalle(doc, 'TOTAL')" class="custom_link">{{ doc.total }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<div class="card mb-2 wow" *ngIf="listaDocumentos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcel()">
      Excel
    </button>
  </div>
</div>




<!-- MODAL detalleDocumento -->
<app-empresas-emitidos-detalle></app-empresas-emitidos-detalle>